import {block} from '../../utils/cn';

import './ColorPicker.scss';

export const b = block('color-picker');

export const DEFAULT_COLOR = '#000000';

export const UPDATE_COLOR_DEBOUNCE_TIME = 200;
